import { unref } from "vue";
export function extractRefHTMLElement(ref) {
  const value = unref(ref);
  if (value) {
    if (value instanceof HTMLElement) {
      return value;
    }
    return value.$el;
  }
  return null;
}
